
const prod_url = "https://admin.smkgiving.org"

const getEnvVar = (viteKey, reactKey) => {
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        return import.meta.env[viteKey];
    }
    return process.env[reactKey];
};

function getBaseUrl() {
    const url2 = getEnvVar("VITE_BASE_URL_2", "REACT_APP_URL_2")
    const url = url2 || getEnvVar("VITE_BASE_URL", "REACT_APP_BASE_URL")

    const final_url = (typeof import.meta !== 'undefined' && import.meta.env
        ? import.meta.env.MODE
        : process.env.NODE_ENV) === "development"
        ? url
        : prod_url;

    return final_url

}

export const BASE_URL = getBaseUrl()
console.log('BASE_URL: ', BASE_URL);
